import * as React from "react";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const MyListingsLoading = ({next}) => cs(
    ["status", (_, next) => UseState({next})],
    ({status}) => next({
        ...status.value == null ? {
            active: false,
        } : {
            active: true,
            message: messages[status.value.type](status.value),
        },
        emulating       : () => status.onChange({type: "emulating"}),
        loadingListing  : () => status.onChange({type: "loadingListing"}),
    }),
);

const messages = {
    "emulating"     : () => "Loading My Listings Templates...",
    "loadingListing": () => "Loading Listing Information...",
};
